import React, { useMemo } from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, DateTime, TextArea, RequiredValidator, EventTriggers } from '../../Components/Form';
import { useSelectable } from '../../Components/Selectable';
import { plural } from '../../Services/helpers';
import { useSkipMany } from '../../Data/Jobs';
import { eventTriggers } from '../../Data/Misc';

const SkipMany = ({isOpen, onClose, then}) => {
    const {selected} = useSelectable();
    const title = `Skipping ${plural(selected.length, '0 jobs', '1 job', `${selected.length} jobs`)}`;

    return <Modal title={title} isOpen={isOpen} setIsOpen={onClose} dismissible>
        {isOpen && <Inner then={then} />}
    </Modal>
}

const Inner = ({then}) => {
    const {selected} = useSelectable();
    const skip = useSkipMany();

    const formattedIds = useMemo(() => {
        return selected.map(id => {
            const x = id.split('-');
            return {customerId: x[0], jobId: x[1]}
        })
    }, [selected]);

    return <Form
            data={{ids: formattedIds}}
            onSubmit={skip}
            afterSubmit={then}
            closeModalOnSubmit
        >

        <DateTime name="skippedOn" label="Skipped at" validators={[RequiredValidator]} defaultNow />
        <TextArea name="notes" label="Notes" />
        <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
        <Actions submit={{label: 'Skip'}} cancel />
    </Form>
}

export default SkipMany;
